export const url = `${process.env.DOMAIN}/v1`;
export const domain = `${process.env.DOMAIN}/v1/`;
export const fileUrl = `${process.env.DOMAIN}`;

export const endPoints = {
    //User Route
    signup: 'user/signup',
    login: 'user/login',
    getUser: 'user/user',
    getFrequencyPackage: 'package/frequency-package',
    package: 'package/package',
    getNearestLocation: 'package/geonear',
    getMinimumValue: 'package/getMinimumValue',
    getCityState: 'package/city-state',
    assignAudioCreation: 'campaign/assignAudioCreation',
    getCityList: 'package/city-by-state',
    getStateList: 'user/state',
    getDistrictList: 'user/district',
    getIndustryList: 'user/industryList',
    getCities: 'user/city',
    getCitiesAll: 'user/cityAll',
    getDaypakage: 'package/day-package',
    getCustomPackage: 'package/custom-package',
    getBudgetPackage: 'package/budget-package',
    getBudgetPackageAll: 'package/get-budget-package',
    getBudgetPackageWithSecondages: 'package/budget-package-secondages',
    choosePackage: 'package/choose-package',
    assignPackageToUser: 'package/assignPackageToUser',
    matchPackageDiscount: 'package/match-package-discount',
    getBaseDiscounts: 'package/discounts',
    audio: 'campaign/audio',
    createCampaign: 'campaign/create-campaign',
    updateCampaignAudio: 'campaign/update-campaign-audio',
    updateCampaign: 'campaign/update-campaign',
    getBroadCastHistory:'common/broadcast',
    campaignList: 'campaign/campaigns',
    getAllCampaign: 'campaign/getAllCampaign',
    getKycDetails: 'user/kycdetails',
    updateKycDetails: 'user/update_Kyc',
    uploadaudioalone: 'campaign/manageAudio',
    checkAlreadyUser: 'user/checkUser',
    checkUserExists: 'user/checkUserexists',
    verifyUserEmail: 'user/verifyUserEmail',
    getPreviousAudio: 'campaign/get-previous-audio',
    getPreviousAudioByUser: 'campaign/getPreviousAudioByUser',
    getAudioRequests: 'campaign/get-audio-requests',
    updateProductionSale: 'campaign/update-production-sale',
    getReconDetails: 'campaign/getReconDetails',
    linkpaymentId: 'campaign/linkpaymentId',
    getcouponCampaigs: 'campaign/getcouponCampaigns',
    dsasignup: "user/dsa-signup",
    getalldsausers: "user/getalldsausers",
    getalldsauserspaginated: "user/getalldsauserspaginated",
    exportDSA: "user/exportDSAUsers",
    dsauserupdate: 'user/dsauserupdate',
    // updateAudiostatus: 'audio/updateaudiostatus',

    //Admin Route
    adminLogin: 'admin/gsuit-login',
    getCityStateRate: 'admin/city-state-rates',
    updateRates: 'admin/city-state-rates/edit',
    getPackage: 'admin/package',
    updateFrequencyPackage: 'admin/package/frequency/update',
    updateBudgetPackage: 'admin/package/budget/update',
    updateBaseDiscount: 'admin/package/discount/update',
    deleteBaseDiscount: 'admin/package/discount/delete',
    addBaseDiscount: 'admin/package/discount/add',
    addRemarksContactUs: 'admin/contacts/remarks/add',
    updateDayPackage: 'admin/package/day/update',
    getContactUs: 'admin/contacts',
    getLeadStatus: 'admin/leadstatus',
    updateContactUs: 'admin/contacts/update',
    updateContractToCampaign: 'admin/campaign/contract',
    getSalesUserPerformance: 'admin/salesuserperformance',
    getCityLatLong: 'admin/city-locations',
    getOnlineVSOfflineReportData: 'admin/online-offline-report-data',

    //audi admin managemnt
    getAudiolist: 'admin/audioadminmanagment/audiomanagment',
    getAudioAdminsData: 'admin/audioadminmanagment/AudioAdminComp',
    deleteAudioAdmin: 'admin/audioadminmanagment/AudioAdminComp',
    getusersofcity: 'admin/getusersofcity',
    getdsaconfig: 'admin/getdsaconfig',
    putdsaconfig: 'admin/putdsaconfig',
    getSpecificRoleUsers: 'admin/getSpecificRoleUsers',
    getMentees: 'admin/getMentees',
    contact: 'common/contact',
    sendotp: 'common/sendotp',
    broadcast: 'common/broadcast',
    addRemoveCampaign: 'admin/campaign/approve-reject-campaign',
    getCoupons: 'admin/coupons',
    createCoupons: 'admin/create-coupon',
    applyCoupon: 'admin/verify-coupon',
    createNONFCTCode: 'admin/create-non-fct-code',
    getNONFCTCodes: 'admin/non-fct-codes',
    applyNONFCTCode: 'admin/verify-non-fct-code',
    forgetpassword: 'user/forgetpassword',
    getAdminsData: "admin/get-alladmin",
    addAdmin: "admin/create-admin",
    deleteAdmin: "admin/delete-admin",
    deleteMultipleAdmin: "admin/delete-multiple-admin",
    downloadAudio: "admin/download",
    addAdminUser: "admin/create-users",
    updateOfflinePayments: "admin/update-offline-payments",
    getNonLinkedPaymentsBasedOnDate: "campaign/getNonLinkedPaymentsBasedOnDate",
    linkFailedCampaignToPayments: "campaign/linkFailedCampaignToPayments",
    deleteFailedCampaign: "campaign/deleteFailedCampaign",
    createSplashScreen: "admin/createSplashScreen",
    updateSplashScreen: "admin/updateSplashScreen",
    getAllSplashScreens: "admin/getAllSplashScreens",
    getCurrentSplashScreen: "user/getCurrentSplashScreen",
    getAllRoles: 'admin/getAllRoles',
    createNewRole: 'admin/createNewRole',
    updateRole: 'admin/updateRole',
    

    //Sales User Route
    salesUserLogin: "sales_user/login",
    salesUseremailLogin: "sales_user/emailLogin",
    salesuserChangePassword:"sales_user/changePassword",
    getAllCampainsOfUser: 'sales_user/getAllCampaignsOfUser',
    getAllSalesUsers: 'sales_user/getAllSalesUsers',
    updatesalesUserdata: 'sales_user/update',
    requestCoupon:"sales_user/coupon/request",
    requestNonFCTCode:"sales_user/nonFCTCode/request",
    updateRequestCoupon:"sales_user/coupon/updateRequest",
    updateRequestNonFCT:"sales_user/nonfctcode/updateRequest",
    getCouponsRequested: 'sales_user/coupon/get',
    getNonFCTCodeRequested: 'sales_user/nonfctcode/get',
    deleteTPRequest: "sales_user/requestDeleteTradePartner",
    getAdminDetails: 'admin/getAdminDetails',
    createCluster: 'admin/cluster/create',
    createClusterOfCluster: 'admin/cluster-of-cluster/create',
    getClusters: 'admin/cluster',
    editCluster: 'admin/cluster',
    editClusterOfCluster: 'admin/cluster-of-cluster',
    deleteClusterOfCluster: 'admin/cluster-of-cluster/delete',
    test: 'user/test',
    getcampaignsbasedondsa: 'campaign/getcampaignsbasedondsa',
    checkpaymentstatus: 'campaign/checkpaymentstatus',
    getprevpayoutdetails: 'campaign/getprevpayoutdetails',
    getcampaignsofAuditAdmin: 'campaign/getcampaignsofAuditAdmin',
    generateinvoice: 'invoice/generateinvoice',
    getInvoices: 'invoice/getInvoices',
    updateinvoice: 'invoice/updateinvoice',
    signinvoice: 'invoice/esign',
    checkPANDuplicateDSA: 'user/checkPANDuplicateDSA',
    uploadTrafficOrder:'campaign/uploadTrafficOrder',
    updateOfflineTransaction: 'campaign/linkofflinepayment',
    getClientKYC: 'campaign/getClientKYC'
};

export const PAGE_SIZE = 10;


// WEBPACK FOOTER //
// ./web/config.js